<section class="card-cont p-lg-4">
    <article class="row">
        <ng-container *ngIf="isLoading; else showContent">
            <section class="col-lg-4 pr-lg-3" *ngFor="let loader of ' '.repeat(9).split('')">
                <div class="skeleton-loader skeleton-loader__program-card row mx-0 mb-4">
                    <div class="skeleton-loader__details col-12 d-flex flex-column text-center p-3">
                        <ngx-skeleton-loader class="mt-5 mb-3" count="1" animation="pulse" [theme]="{
                            'border-radius': '8px',
                            height: '25px',
                            width: '65%',
                            'background-color': '#E4E6ED',
                            'margin-bottom': '5px'
                        }"></ngx-skeleton-loader>
                        <ngx-skeleton-loader count="1" animation="pulse" [theme]="{
                            'border-radius': '8px',
                            height: '15px',
                            width: '40%',
                            'background-color': '#E4E6ED'
                        }"></ngx-skeleton-loader>
                    </div>
                </div>
            </section>
        </ng-container>
        <ng-template #showContent>
            <ng-container *ngIf="programData.length > 0; else noPrograms">
                <div class="col-lg-4" *ngFor="let program of programData | slice:0:dataDisplayCount">
                    <div class="program" [ngStyle]="{ 'background-image': 'url(' + program.mediaUrl + ')'}"
                        (click)="goToProgramDetails(program.id, program.isForMembersOnly)">

                        <div class="program__overlay">
                            <!-- <div (click)="bookmarkCard()">
                                <i class="far fa-bookmark active" [ngClass]="{'active': isActive}"></i>
                            </div> -->
                            <div class="for-members-only-tag--sm" *ngIf="program.isForMembersOnly === true">
                                {{ 'dialogs.forMembersOnlyText' | translate }}
                            </div>
                            <p>{{ program.title }}</p>
                            <!-- <small class="program__equipment">Full Equipment</small> -->
                        </div>
                    </div>
                </div>
                <div class="col-12">
                    <article class="row d-flex justify-content-center">
                        <div class="col-lg-4 col-sm-6">
                            <fitscovery-ui-load-more-button (loadMoreClicked)="displayData()"
                                [showLoadMore]="showLoadMore"></fitscovery-ui-load-more-button>
                        </div>
                    </article>
                </div>
            </ng-container>
            <ng-template #noPrograms>
                <div class="col-12">
                    <h6 class="text-center mt-4 mb-5"> {{ 'pages.noProgramsFoundMessage' | translate }}</h6>
                </div>
            </ng-template>
        </ng-template>
    </article>
</section>
<section class="unlock-overlay" *ngIf="openForMembersOnly">
    <article class="row no-gutters h-100 align-items-center text-center">
        <div class="mx-auto px-3 unlock-overlay-container">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg close-button" viewBox="0 0 16 16" (click)="openForMembersOnly = false"><path d="M1.293 1.293a1 1 0 0 1 1.414 0L8 6.586l5.293-5.293a1 1 0 1 1 1.414 1.414L9.414 8l5.293 5.293a1 1 0 0 1-1.414 1.414L8 9.414l-5.293 5.293a1 1 0 0 1-1.414-1.414L6.586 8 1.293 2.707a1 1 0 0 1 0-1.414z"/></svg>
            <img src="https://d3uee0gs4p7cty.cloudfront.net/icons/member-lock-icon.png" class="icon-lock"
                alt="Lock Icon">
            <h2 *ngIf="isStatusPending !== true" class="my-sm-5 mt-4 mb-5">{{ 'pages.unlockProgram' | translate }}</h2>
            <h2 *ngIf="isStatusPending === true" class="my-sm-5 mt-4 mb-5">{{ 'dialogs.forMembersOnlyText' | translate}}</h2>
            <div class="col-lg-7 col-sm-8 col-9 mx-auto">
                <fitscovery-ui-be-a-member-button [isWithinPage]="true" [isWithinUnlockPage]="true">
                </fitscovery-ui-be-a-member-button>
                <a class="btn btn-back" (click)="backToList(true)">{{ 'dialogs.checkOtherProgramButtonText' | translate}}</a>
            </div>
        </div>
    </article>
</section>